import { BulbFilled } from "@ant-design/icons";
import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import {
  faChevronDown,
  faChevronUp,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { API, selectInput } from "aws-amplify";
import { useState } from "react";
import { useEffect } from "react";
import { FormattedNumber } from "react-intl";
import { TypedUseSelectorHook, useSelector } from "react-redux";

import { RootState } from "../../../app/store";
import playerSlice, {
  PlayerMode,
  selectPlayer,
} from "../../../features/player/playerSlice";
import { selectTheme } from "../../../features/theme/themeSlice";
import useAccount from "../../../hooks/useAccount";

import AccountBalanceMenu from "./AccountBalanceMenu";

const AccountBalance = () => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const player = useAppSelector(selectPlayer);

  const theme = useAppSelector(selectTheme);
  const [update, setUpdate] = useState(false);
  const [amountVisible, setAmountVisible] = useState(false);
  const [inAccountBalanceMenu, setInAccountBalanceMenu] = useState(false);
  useEffect(() => {
    setUpdate(!update);
  }, []);
  const [visible, setVisible] = useState<boolean>();
  return player ? (
    <div
      className={`d-flex f-center logged-controls-account-balance  ${
        player.mode === PlayerMode.KIOSK ? "kiosk-mode" : "pointer"
      }`}
    >
      <div
        className={`valute valute-${theme.language}`}
        style={{ marginRight: "4px" }}
      >
        {player.account && player.mode == PlayerMode.DEFAULT && (
          <>
            {amountVisible && (
              <FormattedNumber
                value={player.balance}
                style="currency"
                currency={player.account.valute}
              />
            )}
            {!amountVisible && <span>&#8226;&#8226;&#8226;&#8226;&#8226;</span>}
          </>
        )}

        {player.account && player.mode == PlayerMode.KIOSK && (
          <div className="flex f-row">
            {amountVisible && (
              <FormattedNumber
                value={
                  player.account.deposit -
                  player.account.expenses +
                  player.account.bonus
                }
                style="currency"
                currency={player.account.valute}
              />
            )}
            {!amountVisible && <span>&#8226;&#8226;&#8226;&#8226;&#8226;</span>}
          </div>
        )}
      </div>
      <div
        className="pointer"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setAmountVisible(!amountVisible);
        }}
      >
        {amountVisible && <FontAwesomeIcon icon={faEye} />}
        {!amountVisible && <FontAwesomeIcon icon={faEyeSlash} />}
      </div>
      {player.mode === PlayerMode.DEFAULT && (
        <div
          tabIndex={0}
          onClick={() => setVisible(!visible)}
          onBlur={() => {
            if (!inAccountBalanceMenu) setVisible(false);
          }}
        >
          {!visible && <FontAwesomeIcon icon={faChevronDown} />}
          {visible && <FontAwesomeIcon icon={faChevronUp} />}&nbsp;
          <AccountBalanceMenu
            visible={visible}
            onHide={() => setVisible(false)}
          />
        </div>
      )}
    </div>
  ) : (
    <div></div>
  );
};

export default AccountBalance;
